module.exports = __webpack_public_path__ + "img/weddings_17_H.0095c82f.webp";